import { render, staticRenderFns } from "./to-destroy-done.vue?vue&type=template&id=72e5045b&scoped=true"
import script from "./to-destroy-done.vue?vue&type=script&lang=js"
export * from "./to-destroy-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5045b",
  null
  
)

export default component.exports